import { uuid } from '@gameday/common/utils'

import { auth, formData, voucher } from '../constants/actions'

const initialState = {
  sessionId: null,
}

const skipMemberId = ({ memberId, ...rest }) => rest

export default (state = initialState, action) => {
  let newState = {}
  switch (action.type) {
    case voucher.INIT_SESSION:
      return state.sessionId
        ? state
        : {
            ...state,
            sessionId: uuid(),
          }
    case voucher.RESET_VOUCHER:
      return initialState
    case voucher.REMOVE_VOUCHER_DATA:
      newState = { ...state }
      delete newState[action.payload]
      return newState
    case voucher.UPDATE_VOUCHER_DATA:
      return {
        ...state,
        ...action.payload,
      }
    case voucher.VALIDATE_VOUCHER:
      return {
        ...state,
        [action.payload.memberId]: {
          ...state[action.payload.memberId],
          ...skipMemberId(action.payload),
          isLoading: true,
        },
      }
    case voucher.VALIDATE_SUCCEEDED: {
      const { memberId, ...restPayload } = action.payload
      return {
        ...state,
        [memberId]: {
          ...state[memberId],
          ...restPayload,
        },
      }
    }
    case voucher.VALIDATE_FAILED:
      return {
        ...state,
        [action.payload.memberId]: {
          ...state[action.payload.memberId],
          balance: 0,
          originalBalance: 0,
          appliedVoucher: null,
          message: action.payload.error,
          isLoading: false,
        },
      }
    case auth.SIGN_OUT:
    case formData.RESET_FORM: {
      return initialState
    }
    default:
      return state
  }
}
